import { render, staticRenderFns } from "./ProductItemSkeleton.vue?vue&type=template&id=137e35f5&scoped=true"
import script from "./ProductItemSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductItemSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e35f5",
  null
  
)

export default component.exports